// ランチャー経由だけ許可の例外（すべてのサーバー共通）。ランチャーを使えない人（Android の Zalith Launcher など）を通す。
import { useState } from 'react';
import type { LauncherGateExempt } from '@mcpanel/core';
import { rawRequest } from '../api/client';
import { errorMessage, useApp } from '../app-context';
import { ErrorAlert } from '../components/ui';
import { usePoll } from '../hooks/usePoll';

const path = '/launcher-gate/exempt';

export function LauncherGateExemptList() {
  const { canOperate, notify } = useApp();
  const list = usePoll(() => rawRequest<LauncherGateExempt[]>('GET', path), 60000, []);
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  const run = async (action: () => Promise<unknown>, done: string) => {
    setBusy(true);
    try {
      await action();
      await list.reload();
      notify(done);
      return true;
    } catch (error) {
      notify(errorMessage(error), true);
      return false;
    } finally {
      setBusy(false);
    }
  };
  const add = async () => {
    const value = name.trim();
    if (await run(() => rawRequest('POST', path, { name: value }), `${value} を例外にしました`)) setName('');
  };
  const remove = (entry: LauncherGateExempt) => {
    if (
      !window.confirm(
        `${entry.name} を例外から外しますか？制限のあるサーバーには、ランチャーなしでは入れなくなります。`,
      )
    )
      return;
    void run(() => rawRequest('DELETE', `${path}/${encodeURIComponent(entry.uuid)}`), `${entry.name} を外しました`);
  };
  const entries = list.data ?? [];
  return (
    <div className="stack" style={{ gap: 4 }}>
      <strong className="small">ランチャーなしで入れる人（すべてのサーバー共通）</strong>
      <ErrorAlert error={list.error} />
      {entries.length > 0 && (
        <div className="row" style={{ flexWrap: 'wrap', gap: 4 }}>
          {entries.map((entry) => (
            <span className="tag" key={entry.uuid}>
              {entry.name}{' '}
              {canOperate && (
                <button
                  className="btn ghost small"
                  disabled={busy}
                  onClick={() => remove(entry)}
                  aria-label={`${entry.name} を例外から外す`}
                >
                  ×
                </button>
              )}
            </span>
          ))}
        </div>
      )}
      {canOperate && (
        <form
          className="row"
          onSubmit={(event) => {
            event.preventDefault();
            if (name.trim()) void add();
          }}
        >
          <input
            className="input"
            value={name}
            onChange={(event) => setName(event.target.value)}
            placeholder="Minecraft の名前（Java 版）"
            aria-label="ランチャーなしで入れる人の Minecraft の名前"
            maxLength={16}
          />
          <button className="btn small" type="submit" disabled={busy || !name.trim()}>
            追加
          </button>
        </form>
      )}
      <span className="small muted">
        Android（Zalith Launcher など）でランチャーを使えない人を、名前（UUID）で通します。どのランチャーかは見ません。
      </span>
    </div>
  );
}
